export const LastSelectedAccountId_KEY = 'composableai.lastSelectedAccountId';
export const LastSelectedProjectId_KEY = 'composableai.lastSelectedProjectId';
//# sourceMappingURL=constants.js.map